export default __webpack_public_path__ + "static/media/c2176f5fbc5f1ec4.8c8d72f3e4e959f0b5124f5f6c25c976.svg";